/*
 * @Description: 自然人
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { accountManagement } from '@/api/ajax';
import fields from '../fields';
import search from '../search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import roleAction from '../../roleAction';

let newRole = {
  name: '新增角色',
  icon: '',
  type: 'primary',
  fn(app, table) {
    table.$xrkDialog({
      title: '新增角色',
      width: '40%',
      showCancel: true,
      showConfirm: true,
      confirmText: '新增',
      success(params) {
        if (params.confirm) {
          if(!params.content.roleName.trim()){
            table.$message.error('角色名称不能为空')
            return
          }
          accountManagement
            .roleAddOrEdit({
              type: 1,
              roleName: params.content.roleName,
              roleId: '-1'
            })
            .then(() => {
              params.content.$message.success('新增成功');
              params.dialog.remove();
              table.reGetPage();
            });
        }
      },
      $slots: {
        default: table.$createElement(roleAction, { props: { actionType: 1 } })
      }
    });
  }
};

let example = new TableRenderClass({ fields, search });
let part = example.createPart({
  name: '子账号管理',
  search: [],
  list: accountManagement.subaccountManagementRoleList,
  defaultQueryHotfix: { type: 1 },
  fields: ['index', 'roleName', 'createDt', 'associatedAccounts', 'operate'],
  moreBtnArr: [newRole]
});

export default part;
